<template>
  <div class="presenter-view-overlay-wrapper"
    :style="{left: !isMobile ? `${left}px` : ''}"
    :class="{mobile: isMobile}">
    <div class="open-wrapper" v-if="isMobile" @click="openClose">
      <rp-sprite class="right-icon" name="chevron_right"/>
    </div>
    <div class="presenter-view-overlay"
      :style="{width: !isMobile ? `${width}px` : ''}"
      :class="{'is-open': isOpen}"
      @click="openClose">
      <div class="row">
        <div class="cell cell-1">
          <div class="number safari-fix">
            <NumberChart :numberVal="patients" :presenterView="true"/>
          </div>
          <div class="label">
            Patients
          </div>
        </div>
        <div class="cell cell-1">
          <div class="number safari-fix">
            <NumberChart :numberVal="iols" :presenterView="true"/>
          </div>
          <div class="label">
            IOLs
          </div>
        </div>
        <div class="cell cell-1">
          <div class="number safari-fix">
            <NumberChart :numberVal="surgeons" :presenterView="true"/>
          </div>
          <div class="label">
            Surgeons
          </div>
        </div>
      </div>
      <div class="row">
        <div class="cell cell-1">
          <div class="number safari-fix">
            <NumberChart :numberVal="countries" :presenterView="true"/>
          </div>
          <div class="label">
            Countries
          </div>
        </div>
        <div class="cell cell-2">
          <div class="label">
            Satisfaction With Outcomes
          </div>
          <div class="number">
            <RangeMap :progress="satisfactionWithOutcomes"
                :numberVal="satisfactionWithOutcomes"/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="cell cell-3">
          <div class="label">
            Spectacle independence
          </div>
          <div class="numbers-wrapper">
            <div class="number">
              <RangeMap :progress="spectacleDistance"
                  :numberVal="spectacleDistance"/>
              DISTANCE
            </div>
            <div class="number">
              <RangeMap :progress="spectacleIntermediate"
                  :numberVal="spectacleIntermediate"/>
              INTERMEDIATE
            </div>
            <div class="number">
              <RangeMap :progress="spectacleNear"
                  :numberVal="spectacleNear"/>
              NEAR
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="cell cell-3">
          <div class="label">
            Dysphotopsia
          </div>
          <div class="numbers-wrapper">
            <div class="number">
              <RangeMap :progress="dysphotopsiaDay"
                  :numberVal="dysphotopsiaDay"/>
              DURING THE DAY
            </div>
            <div class="number">
              <RangeMap :progress="dysphotopsiaNight"
                  :numberVal="dysphotopsiaNight"/>
              DURING THE NIGHT
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="cell cell-3">
          <div class="label">
              PCO
          </div>
          <div class="numbers-wrapper">
            <div class="number">
              <RangeMap :progress="pco12"
                  :numberVal="pco12"/>
              0-12 MTHS
            </div>
            <div class="number">
              <RangeMap :progress="pco24"
                  :numberVal="pco24"/>
              12-24 MTHS
            </div>
            <div class="number">
              <RangeMap :progress="pco36"
                  :numberVal="pco36"/>
              24-36 MTHS
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RangeMap from 'raypro_ui/src/components/ui/charts/PieProgressChart'
import NumberChart from 'raypro_ui/src/components/ui/charts/NumberChart'
import Sprite from 'raypro_ui/src/components/ui/Sprite'

export default {
  components: {
    'rp-sprite': Sprite,
    RangeMap,
    NumberChart
  },

  data() {
    return {isOpen: false}
  },

  props: {
    presenterData: Array,
    width: Number,
    left: Number,
    isMobile: Boolean
  },

  methods: {
    openClose() {
      this.isOpen = !this.isOpen
    }
  },

  computed: {
    patients() {
      const patientsMap = {}

      for(const data of this.presenterData) {
        for(const patient of data.patient_numbers) {
          patientsMap[patient] = true
        }
      }
      return Object.keys(patientsMap).length
    },

    iols() {
      let iolsSum = 0

      for(const data of this.presenterData) {
        iolsSum += data.iols_numbers
      }
      return ~~iolsSum
    },

    surgeons() {
      const surgeonsMap = {}

      for(const data of this.presenterData) {
        for(const surgeon of data.surgeons) {
          surgeonsMap[surgeon] = true
        }
      }
      return Object.keys(surgeonsMap).length
    },

    countries() {
      const countriesMap = {}

      for(const data of this.presenterData) {
        countriesMap[data.hospital.country.id] = true
      }
      return Object.keys(countriesMap).length
    },

    satisfactionWithOutcomes() {
      let satisfactionWithOutcomesFinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.satisfaction_with_outcomes.count
      }
      for(const data of this.presenterData) {
        satisfactionWithOutcomesFinalSum += data.satisfaction_with_outcomes.percentage *
          data.satisfaction_with_outcomes.count / totalCount
      }
      return ~~satisfactionWithOutcomesFinalSum
    },

    spectacleDistance() {
      let spectacleDistanceFinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.spectacle_independance.distance.count
      }
      for(const data of this.presenterData) {
        spectacleDistanceFinalSum += data.spectacle_independance.distance.percentage *
          data.spectacle_independance.distance.count / totalCount
      }
      return ~~spectacleDistanceFinalSum
    },

    spectacleIntermediate() {
      let spectacleIntermediateFinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.spectacle_independance.intermediate.count
      }
      for(const data of this.presenterData) {
        spectacleIntermediateFinalSum += data.spectacle_independance.intermediate.percentage *
          data.spectacle_independance.intermediate.count / totalCount
      }
      return ~~spectacleIntermediateFinalSum
    },

    spectacleNear() {
      let spectacleNearFinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.spectacle_independance.near.count
      }
      for(const data of this.presenterData) {
        spectacleNearFinalSum += data.spectacle_independance.near.percentage * data.spectacle_independance.near.count / totalCount
      }
      return ~~spectacleNearFinalSum
    },

    dysphotopsiaDay() {
      let dysphotopsiaDayFinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.dysphotopsia.during_day.count
      }
      for(const data of this.presenterData) {
        dysphotopsiaDayFinalSum += data.dysphotopsia.during_day.percentage *
          data.dysphotopsia.during_day.count / totalCount
      }
      return ~~dysphotopsiaDayFinalSum
    },

    dysphotopsiaNight() {
      let dysphotopsiaNightFinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.dysphotopsia.during_night.count
      }
      for(const data of this.presenterData) {
        dysphotopsiaNightFinalSum += data.dysphotopsia.during_night.percentage *
          data.dysphotopsia.during_night.count / totalCount
      }
      return ~~dysphotopsiaNightFinalSum
    },

    pco12() {
      let pco12FinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.pco[0].based_on
      }
      for(const data of this.presenterData) {
        pco12FinalSum += data.pco[0].count * data.pco[0].based_on / totalCount
      }
      return Number.isNaN(pco12FinalSum) ? 0 : Math.round(pco12FinalSum * 100)
    },

    pco24() {
      let pco24FinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.pco[1].based_on
      }
      for(const data of this.presenterData) {
        pco24FinalSum += data.pco[1].count * data.pco[1].based_on / totalCount
      }
      return Number.isNaN(pco24FinalSum) ? 0 : Math.round(pco24FinalSum * 100)
    },

    pco36() {
      let pco36FinalSum = 0
      let totalCount = 0

      for(const data of this.presenterData) {
        totalCount += data.pco[2].based_on
      }
      for(const data of this.presenterData) {
        pco36FinalSum += data.pco[2].count * data.pco[2].based_on / totalCount
      }
      return Number.isNaN(pco36FinalSum) ? 0 : Math.round(pco36FinalSum * 100)
    },
  }
}
</script>

<style>
_::-webkit-full-page-media, _:future, :root .presenter-view-overlay-wrapper .safari-fix {
  display: flex;
  flex-direction: column;
}

_::-webkit-full-page-media, _:future, :root .presenter-view-overlay-wrapper .safari-fix .chart-inner {
  display: flex;
  flex-direction: column;
}

_::-webkit-full-page-media, _:future, :root .router-view-wrapper.fullscreen {
  display: flex;
  flex-direction: column;
}

_::-webkit-full-page-media, _:future, :root .presenter-view-google-map#google-map {
  flex-grow: 1;
}

_::-webkit-full-page-media, _:future, :root .presenter-view {
  flex-grow: 1;
}

_::-webkit-full-page-media, _:future, :root .presenter-view .map-wrapper{
  display: flex;
  flex-direction: column;
}

</style>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.presenter-view-overlay-wrapper
  position: relative
  position: absolute
  top: 30px
  bottom: 30px

  .open-wrapper
    pointer-events: all
    padding: 10px
    position: absolute
    top: 10px
    left: 10px
    background-color: white
    border-radius: 4px
    box-shadow: 0 0 5px 0px $color-shadow

    svg
      width: 24px
      height: 24px
      fill: $color-side-nav

  .presenter-view-overlay
    display: flex
    flex-direction: column
    justify-content: space-between
    height: 100%

    .row
      width: 100%
      height: calc(100% / 5 - 10px)
      display: flex
      justify-content: space-between

      .cell
        height: 100%
        background-color: white
        border-radius: 4px
        box-shadow: 0 0 5px 0px $color-shadow
        display: flex
        justify-content: center
        align-items: center
        flex-direction: column
        padding: 10px 30px

        .number
          color: $color-text-highlight
          display: flex
          max-height: 100%

        .label
          font-size: 22px
          color: $color-text-light

      .cell-1
        padding: 30px 20px
        width: calc(100% / 3 - 10px)

      .cell-2
        width: calc(100% / 3 * 2 - 5px)
        flex-direction: row

        .label
          width: 45%
          padding-right: 10px

        .number
          width: 55%
          height: 100%

      .cell-3
        width: 100%
        flex-direction: row

        .label
          width: 30%
          padding-right: 10px

        .numbers-wrapper
          display: flex
          height: 100%
          flex-grow: 1
          width: 75%

          .number
            height: 100%
            display: flex
            flex-direction: column
            align-items: center
            font-size: 14px
            color: $color-text-light

            .chart-inner
              height: calc(100% - 32px)
              padding-bottom: 10px

  &.mobile
    top: 0
    bottom: 0
    padding: 10px
    z-index: 5
    pointer-events: none

    .presenter-view-overlay
      transition: transform .3s
      transform: translateX(calc(-100% - 35px))
      pointer-events: all

      &.is-open
        transform: translateX(0)

      .row

        .cell
          padding: 10px

          .label
            font-size: 12px

          .numbers-wrapper
            flex-grow: unset

            .number
              justify-content: center
              font-size: 10px
</style>



// WEBPACK FOOTER //
// src/components/PresenterViewOverlay.vue